<template>
    <div>
        <div v-if="errors" class="p-4 my-4 text-sm text-red-700 bg-red-100 rounded-lg" role="alert">
            <div v-for="(error, errorIndex) in errors" :key="'error-' + errorIndex">
                {{error}}
            </div>
        </div>
        <h1 class="font-bold text-2xl">Nouvelle adresse</h1>
        <div class="flex">
            <div :class="displayMap ? 'lg:w-1/2' : 'w-full'">
                <div class="flex items-center my-5">
                    <div class="text-lg font-light">Je m'appelle </div>
                    <input type="text" class="grow text-lg font-bold border-0 border-b focus:border-transparent focus:border-b-black focus:ring-0 ml-3 py-1 px-0">
                </div>
                <div class="flex items-center mb-5">
                    <div class="text-lg font-light">J'habite en</div>
                    <select class="grow font-bold p-2 w-40 ml-3 border-gray-300 rounded-xl">
                        <option>France</option>
                        <option>Belgique</option>
                    </select>                    
                </div>
                <div class="flex items-center mb-5">
                    <div class="text-lg">A l'adresse : </div>
                    <input type="text" class="grow text-lg font-bold border-0 border-b focus:border-transparent focus:border-b-black focus:ring-0 ml-3 py-1 px-0">
                </div>
                <!-- Prenom -->
                <!-- <label class="block font-light text-gray-600">{{$t('composants.sav-map-input.prenom')}}</label>
                <sav-input
                type="text"
                autocorrect="off"
                spellcheck="false"
                autocomplete="off"
                v-model="prenomInput"
                class="mb-3"
                /> -->
                <!-- Nom -->
                <!-- <label class="block font-light text-gray-600">{{$t('composants.sav-map-input.nom')}}</label>
                <sav-input
                type="text"
                autocorrect="off"
                spellcheck="false"
                autocomplete="off"
                v-model="nomInput"
                class="mb-3"
                />
                <label class="block font-light text-gray-600">{{$t('composants.sav-map-input.adresse')}}</label>
                <div class="flex items-end mb-3">
                    <select v-model="addressCountry" class="p-2 border border-gray-300 rounded-lg rounded-r-none bg-gray-50">
                        <option v-for="(country, countryFlag) in countries" :key="'flag-' + countryFlag" :value="country">{{country.flag}}</option>
                    </select>
                    <sav-input
                    test-id-value="address-input"
                    type="text"
                    autocorrect="off"
                    spellcheck="false"
                    autocomplete="off"
                    v-model="address"
                    @input="searchAddress"
                    class="grow"
                    class-src="rounded-l-none border-l-0"
                    />
                </div>
                <div v-if="results && results.length > 0" style="height: 330px; overflow-y: auto">
                    <template v-for="(result, index) in results">
                        <div
                        :test-id="'address-search-result-' + index"
                        @click="selectAddress(result)"
                        class="p-6 mb-3 bg-white shadow my-rounded"
                        :key="index"
                        >
                            {{result.place_name}}
                        </div>
                    </template>
                </div>
                <template v-if="selectedAddress">
                    <button @click="emitAddress" test-id="btn-add-address" class="px-4 py-2 mt-3 text-sm font-light text-white duration-200 bg-green-500 border-green-500 rounded hover:bg-green-600">
                        Valider
                    </button>
                </template>
            -->
            </div>
            <div :class="displayMap ? 'lg:w-1/2' : ''">
                <sav-map
                v-if="displayMap"
                class="block w-full mt-3"
                custom-class="shadow my-rounded"
                height="580"
                :position="{
                    longitude: selectedAddress ? selectedAddress.center[0] : '2.213749',
                    latitude: selectedAddress ? selectedAddress.center[1] : '46.227638',
                    zoom: selectedAddress ? 14 : 2
                }"
                :markers="markers"
                ></sav-map>
            </div>
        </div>
    </div>
</template>

<script>
import MapService from '@/services/map.service'
import AddressTool from '@/tools/AddressTool'
import apiService from '@/services/api.service'

export default {
    props: {
        default: {
            type: String
        },
        nom: {},
        prenom: {},
        map: {
            type: Boolean,
            default: true
        },
    },
    watch: {
        default: async function(value) {
            this.setDefaultData()
        },

        map: function(value) {
            this.displayMap = value
        },
        addressCountry: function(value) {
            this.results = []
            this.searchAddress()
        }
    },

    data() {
        return {
            address: "",
            addressCountry: null,
            countries: [
                {
                    flag: "🇫🇷",
                    value: "FR"
                },
                {
                    flag: "🇧🇪",
                    value: "BE"
                }
            ],
            timer: null,
            results: [],
            selectedAddress: null,
            displayMap: true,
            validated: false,
            markers: null,
            nomInput: null,
            prenomInput: null,
            marker: {
                longitude: '2.213749',
                latitude: '46.227638',
                callback: null
            },
            errors: null,
        }
    },

    methods: {
        searchAddress() {
            if (this.address) {
                if (this.selectedAddress && this.selectedAddress.place_name == this.address) {
                    return
                } else {
                    this.markers = []
                    this.selectedAddress = null
                }
                clearTimeout(this.timer)
                this.timer = setTimeout(async () => {
                    let responseAddresses = await MapService.search(this.address, this.addressCountry.value)
                    this.results = responseAddresses.filter(place => place.place_type == 'poi' || place.place_type == 'address')
                }, 200)
            } else {
                this.results = []
            }
        },

        selectAddress(result) {
            this.results = null
            this.selectedAddress = result
            this.marker.longitude = result.center[0]
            this.marker.latitude = result.center[1]
            this.markers.push(this.marker)
            this.address = result.place_name
        },

        resetSearch() {
            this.results = []
            this.selectedAddress = null
            this.address = ""
            this.setPropsValues()
            this.searchAddress()
        },

        emitAddress() {
            if (this.nomInput && this.prenomInput && this.selectedAddress) {
                this.$emit('input', {...AddressTool.convertApi(this.selectedAddress), nom: this.nomInput, prenom: this.prenomInput})
            } else {
                this.errors = [this.$t('composants.sav-map-input.merci_de_saisir_tout_les_champs')]
            }
        },

        async setDefaultData() {
            this.address = this.default
            if (this.addressCountry) {
                let addressList = await MapService.search(this.address, this.addressCountry.value)
                this.addressSelected = addressList[0]
            }
        },

        async setPropsValues() {
            if (this.default) {
                this.setDefaultData()
            }
            if (this.map !== undefined) {
                this.displayMap = this.map
            }
            let user = null
            if (!this.nom || !this.prenom) {
                user = await apiService.getUser()
            }
            this.nomInput = this.nom ? this.nom : user.nom
            this.prenomInput = this.prenom ? this.prenom : user.prenom
        }
    },

    async mounted() {
        this.setPropsValues()
        this.addressCountry = this.countries[0]
        this.displayMap = this.map
    }
}
</script>



// WEBPACK FOOTER //
// src/components/SavMapInput2.vue